module.exports = __webpack_public_path__ + "static/img/1-2.7b47834.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/mobile/aboutUs/1-2.png
// module id = JMFP
// module chunks = 1